module.exports = "<div class=\"form-component\">\r\n  <div class=\"fc-title\">\r\n    Synchronization Candidates\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/syncCandidatesDesigner.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/flow-actions/syncCandidatesDesigner.component.html
// module chunks = main